import TorneoType from "../types/TorneoType";
import { observable, makeObservable } from 'mobx';
import TorneoHelper from "./TorneoHelper";

export default class TorneoStore {

  static instance:any = null;
  public torneos: Array<TorneoType> = TorneoHelper.getTorneos();
  // private torneos: TorneoType[] = torneosMock ;
  constructor() {
    makeObservable(this, {
      torneos: observable,
    });
  }

  static getInstance() {
    if (this.instance == null) this.instance = new TorneoStore();
    return this.instance;
  }

  public getAllTorneos() {
    return TorneoHelper.getTorneos();
    // return this.torneos;
    // let TorneoHelper = new TorneoHelper();
    // return TorneoHelper
    //   .getAllClients()
    //   .then((res) => {
    //     return res;
    //   })
    //   .catch((err) => {
    //     return err;
    //   });
  }

  public addTorneo(newTorneo: TorneoType) {
    let torneosAux = [...this.torneos]
    let torneoId = (new Date()).getTime();
    torneosAux?.push({id: torneoId, name: newTorneo.name, date: newTorneo.date, status: 'No Iniciado', turns: newTorneo.turns, doublets: newTorneo.doublets, numZeros: newTorneo.numZeros, numJuegos: newTorneo.numJuegos, championType: newTorneo.championType, roundNum: -1, roundResults: [], matchCuadrant: undefined});
    this.torneos = torneosAux;
    TorneoHelper.saveTorneos(this.torneos);
    return torneoId;
  }
  
  public async saveTorneo(updatedTorneo: TorneoType) {
    // let torneosAux = [...this.torneos]
    this.torneos?.forEach((torneoAux, index) => {
      if (this.torneos[index].id === updatedTorneo.id)
        this.torneos[index] = updatedTorneo
    });
    // this.torneos = torneosAux;
    TorneoHelper.saveTorneos(this.torneos);
    // let torneoHelper = new TorneoHelper();
    // return TorneoHelper
    //   .saveTorneo(payload)
    //   .then((res) => {
    //     return res;
    //   })
    //   .catch((err) => {
    //     return err.response;
    //   });
  }

  public async deleteTorneo(torneoId: number) {
    let torneosAux = [...this.torneos];
    this.torneos = torneosAux.filter((torneoItem) => torneoItem.id !== torneoId);

    TorneoHelper.saveTorneos(this.torneos);
    // let TorneoHelper = new TorneoHelper();
    // return TorneoHelper
    //   .deleteTenant(torneoId)
    //   .then((res) => {
    //     ShowSuccessToast('Torneo borrado');
    //     return res;
    //   })
    //   .catch((err) => {
    //     ShowErrorToast('Error borrando el torneo');
    //     return err;
    //   });
  }
}
